import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const INTEREST_OPTIONS = [
  { value: "funding", label: "Funding" },
  { value: "sponsorship", label: "Sponsorship" },
  { value: "partnership", label: "Partnership" },
  { value: "collaboration", label: "Collaboration" },
  { value: "events", label: "Events" },
  { value: "hiring_talent", label: "Hiring Talent" },
  { value: "training_certification", label: "Training & Certification" },
  { value: "joining_community", label: "Joining the Community" },
];

export const LINKEDIN_GROUP_URL = "https://www.linkedin.com/groups/14941087/";
